<template>
  <div class="price">
    <template v-if="showSell">
      <CurrencyFormatter
        class="sell-price"
        :value="computedSellPrice"
        data-test-id="text__product-price"
      />
      <CurrencyFormatter
        v-if="showSell"
        class="full-price"
        :value="computedFullPrice"
        data-test-id="text__product-old-price"
      />
    </template>
    <CurrencyFormatter
      v-else
      class="sell-price"
      :value="computedFullPrice"
      data-test-id="text__product-price"
    />

    <template v-if="badges.length && showBanners">
      <div v-if="isMobileOrTablet" class="badges">
        <badge v-for="badge in badges" :key="badge.id" :badge="badge" />
      </div>

      <template v-else>
        <badge v-for="badge in badges" :key="badge.id" :badge="badge" />
      </template>
      <discount-time-badge v-if="showDiscount && showBanners" :discount-timer="discountTimer" />
    </template>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useMedia } from '@mm-frontend/mm-web-ui-kit';
import Badge from './badge.vue';
import type { IBadge } from '../../models/badge';
import { CurrencyFormatter } from '@/components';
import type { ProductPageQuery } from '@/shared/apollo-api/__generated__/types';
import DiscountTimeBadge from './discount-time-badge.vue';
interface Props {
  sellPrice: number;
  fullPrice?: number;
  badges?: IBadge[];
  discountTimer?: NonNullable<ProductPageQuery['product']['skuList'][0]['discountTimer']>;
  showBanners?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  fullPrice: undefined,
  badges: () => [],
  discountTimer: undefined,
  showBanners: false,
});

const { isMobileOrTablet } = useMedia();

const showDiscount = computed(() => {
  if (props.discountTimer) {
    return props.discountTimer.endDate > Date.now();
  }
  return false;
});

const computedSellPrice = computed(() => {
  return props.sellPrice;
});

const computedFullPrice = computed(() => {
  return props.fullPrice || 0;
});

const showSell = computed(() => {
  return props.fullPrice ? props.fullPrice !== props.sellPrice : false;
});
</script>
<style lang="stylus" scoped>
.price
  display flex
  align-items center
  gap 8px
  flex-wrap wrap
  .sell-price
    font-weight 600
    font-size 28px
    color Gray(DK40)
  .full-price
    font-weight: 400
    font-size 14px
    line-height 18px
    letter-spacing -0.01em
    text-decoration-line line-through
    color var(--text-tertiary)
  .badges
    display flex
    align-items center
    gap 6px
    flex-wrap wrap
</style>
